module.exports = __webpack_public_path__ + "static/media/email-icon.3fd37067.png";